export default __webpack_public_path__ + "static/media/crate-img-new.e4081c37.png";